import { PortfolioManager } from '@/widgets/portfolio-manager';

export const PortfolioPage = () => <PortfolioManager />;
